import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState, useMemo, useEffect } from 'react';
import DataSource from 'devextreme/data/data_source';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import ArrayStore from "devextreme/data/array_store";
import WidgetTools from "./widgetTools";
import { removeWidget } from "src/redux/supervisorSlice";

import MonitorWSService from 'src/services/monitorwsservice';
import {
    DataGrid, Column, StateStoring, Paging, Sorting, SearchPanel, Scrolling
} from 'devextreme-react/data-grid';



function DialersSummary(props) {

    const { t } = useTranslation();
    const [groups, setGroups] = useState(0);
    const dataSource = useMemo(() => {
        return new DataSource({
            store: new ArrayStore({
                key: 'groupId',
                data: []
            }),
            reshapeOnPush: true
        })
    }, []);


    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/dialerscallssummary", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("dialerscallssummary");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {

        if (props.connected) {
            MonitorWSService.stompClient.send("/app/subscribe/dialerscallssummary", {}, JSON.stringify({
                token: props.token
            }));
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/dialerscallssummary/`, updateState, { id: "dialerscallssummary" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const updateState = (groups) => {

        if (!document.hidden) {
            
            let data = JSON.parse(groups.body);
            let groupIds = dataSource.items().map(x => x.groupId);
            data.forEach(x => {
                var answerdPercentage = Math.round(x.answerd / x.totalCalls * 100);
                var notAnsweredPercentage = Math.round(x.notAnswered / x.totalCalls * 100);
                var busyPercentage = Math.round(x.busy / x.totalCalls * 100);
                var noAgentPercentage = Math.round(x.noAgent / x.totalCalls * 100);
                var abandonedPercentage = Math.round(x.abandoned / x.totalCalls * 100);

                x.answerdStr = x.answerd + ` (${answerdPercentage}%)`;
                x.notAnsweredStr = x.notAnswered + ` (${notAnsweredPercentage}%)`;
                x.busyStr = x.busy + ` (${busyPercentage}%)`;
                x.noAgentStr = x.noAgent + ` (${noAgentPercentage}%)`;
                x.abandonedStr = x.abandoned + ` (${abandonedPercentage}%)`;
            })

            groupIds.forEach((x, i) => {

                if (data.map(c => c.groupId).indexOf(x) === -1) {
                    dataSource.store().push([{ type: 'remove', key: x }]);
                }
            });

            data.forEach(v => {
                if (groupIds.indexOf(v.groupId) > -1) {
                    dataSource.store().push([{ type: 'update', key: v.groupId, data: v }]);
                } else {
                    dataSource.store().push([{ type: 'insert', data: v }]);
                }
            });

            setGroups(data.length);
        }
    }


    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} id="dialerssummarywidget">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-office")} /> {t("dialerssummary")} <span className="badge badge-light-primary fs-base">{groups}</span></span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={null}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ padding: "0px", height: "360px" }} >

                <DataGrid
                    id="dialerssummarytable"
                    dataSource={dataSource}
                    showBorders={false}
                    columnAutoWidth={true}
                    width={"100%"}
                    height={"100%"}
                    allowColumnResizing={true}
                    loadPanel={{ enabled: false }}
                    rtlEnabled={props.rtl}
                    repaintChangesOnly={true}
                >
                    <Sorting mode={"single"} />
                    <StateStoring
                        enabled={true}
                        type="localStorage"
                        storageKey={`dialersSummaryTable_${props.identifier}_user${props.id}`}
                    />
                    <Paging enabled={false} />
                    <SearchPanel
                        visible={true}
                        width={240}
                        placeholder={t("search")}
                    />
                    <Scrolling
                        rowRenderingMode={"virtual"}
                        columnRenderingMode={"virtual"}
                    ></Scrolling>
                    <Column cssClass={"align-middle"} dataField="groupId" visible={false} showInColumnChooser={false} />
                    <Column cssClass={"align-middle"} dataField="name" caption={t("campaign")} width={100} />
                    <Column cssClass={"align-middle"} dataField="totalCalls" caption={t("calls")} width={100} />
                    <Column cssClass={"align-middle"} dataField="answerdStr" caption={t("attended")} width={100} />
                    <Column cssClass={"align-middle"} dataField="notAnsweredStr" caption={t("missed")} width={100} />
                    <Column cssClass={"align-middle"} dataField="busyStr" caption={t("BUSY")} width={100} />
                    <Column cssClass={"align-middle"} dataField="noAgentStr" caption={t("WITHOUTAGENTS")} width={100} />
                    <Column cssClass={"align-middle"} dataField="abandonedStr" caption={t("abandoned")} width={100} />
                </DataGrid>
            </div>

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        id: state.supervisor.id,
        rtl: state.parameters.rtl,
        connected: state.parameters.connected
    };
};

export default connect(mapStateToProps, { removeWidget })(DialersSummary);